var _defs, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#2f4794;}.cls-4{fill:#fcf5f9;}.cls-5{fill:#ee2d28;}.cls-6{fill:#fff;}.cls-7{fill:#cd202d;}.cls-8{stroke:#2e3192;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 9.92,
    r: 9.91
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.42 -0.35 26.42 20.23 26.41 20.23 -6.41 20.23 -6.41 -0.35 26.42 -0.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "26.42 18.09 26.42 20.23 26.41 20.23 23 20.23 12.92 13.91 11.91 13.28 10.72 12.54 10.33 12.28 9.12 11.53 8.66 11.24 8.29 11.01 7.52 10.53 7.28 10.38 6.91 10.14 3.33 7.9 1.72 6.89 -6.41 1.79 -6.41 -0.35 -6.38 -0.39 -6.32 -0.35 -2.99 -0.35 7.28 6.09 8.29 6.72 8.55 6.89 10.16 7.9 10.33 8 10.94 8.39 11.91 9 12.08 9.1 12.92 9.63 13.75 10.14 15.96 11.53 17.56 12.54 26.42 18.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.42 20.17 26.43 20.24 24.23 20.23 12.92 13.14 11.96 12.54 11.91 12.51 10.94 11.9 10.35 11.53 9.28 10.85 8.29 10.23 8.14 10.14 7.52 9.75 7.28 9.6 4.56 7.9 2.96 6.89 -6.41 1.01 -6.41 -0.4 -6.38 -0.39 -6.32 -0.35 5.23 6.89 6.84 7.9 7.28 8.17 8.29 8.81 8.66 9.04 9.28 9.43 10.42 10.14 11.91 11.08 12.08 11.19 12.63 11.53 12.92 11.72 14.23 12.54 26.42 20.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "26.42 0.06 26.42 2.2 18.93 6.89 17.33 7.9 13.75 10.14 12.92 10.66 12.08 11.19 11.91 11.29 11.54 11.53 10.94 11.9 10.33 12.28 9.93 12.54 8.29 13.57 7.28 14.2 -2.35 20.23 -6.41 20.23 -6.41 18.49 3.09 12.54 4.69 11.53 6.91 10.14 7.28 9.91 7.52 9.75 8.29 9.28 8.66 9.04 10.33 8 10.49 7.9 11.91 7 12.1 6.89 12.92 6.37 23.64 -0.35 26.16 -0.35 26.42 0.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.33 0.16 15.61 6.89 14 7.9 12.92 8.57 12.08 9.1 11.91 9.21 10.42 10.14 9.28 10.85 8.66 11.24 8.29 11.48 8.21 11.53 7.28 12.11 6.6 12.54 -5.67 20.23 -6.41 20.23 -6.41 19.27 4.32 12.54 5.93 11.53 7.28 10.69 7.52 10.53 8.14 10.14 8.29 10.05 9.28 9.43 10.94 8.39 11.72 7.9 11.91 7.78 12.92 7.14 13.33 6.89 24.87 -0.35 26.02 -0.35 26.42 -0.35 26.42 0.1 26.33 0.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -6.44,
    y: 6.89,
    width: 32.87,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -6.44,
    y: 7.9,
    width: 32.87,
    height: 3.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 8.28,
    y: -0.35,
    width: 3.63,
    height: 20.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "11.9 12.54 12.92 12.54 12.92 20.23 7.27 20.23 7.27 12.54 8.28 12.54 8.28 6.89 7.27 6.89 7.27 -0.35 12.92 -0.35 12.92 6.89 11.9 6.89 11.9 12.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.26,
    y: -0.35,
    width: 3.67,
    height: 20.58
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 10,
    cy: 10.08,
    r: 9.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.52c974fe311dd7710ad9280292745ade.svg";
export { ForwardRef as ReactComponent };